import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConfigurationService} from '../../../../core/api/configuration/configuration.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-practice-edit',
  templateUrl: './practice-edit.component.html',
  styleUrls: ['./practice-edit.component.scss']
})
export class PracticeEditComponent implements OnInit {

  title = '';
  errors = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: { criteria: any, isCreate: boolean },
              private dialogRef: MatDialogRef<PracticeEditComponent>,
              private configurationService: ConfigurationService,
              private snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.title = this.data.criteria.title;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  checkErrors(): void {
    this.errors = '';
    if (this.data.criteria.name === '') {
      this.errors = 'Tous les champs sont requis !';
    }
  }

  submit(): void {
    if (this.data.isCreate) {
      this.configurationService.createCriteriaPractice(this.data.criteria).subscribe(data => {
        this.snackBar.open('La discipline a été ajoutée.');
        this.dialogRef.close(true);
      }, (error) => {
        if (error.status === 422) {
          this.errors = 'Tous les champs sont requis !';
        } else {
          this.errors = 'Une erreur est survenue.';
        }
      });
    } else {
      this.configurationService.updateCriteriaPractice(this.data.criteria.id, this.data.criteria).subscribe(data => {
        this.snackBar.open('La discipline a été modifiée.');
        this.dialogRef.close(true);
      }, (error) => {
        if (error.status === 422) {
          this.errors = 'Tous les champs sont requis !';
        } else {
          this.errors = 'Une erreur est survenue.';
        }
      });
    }
  }

  onError(): boolean {
    return this.errors !== '';
  }

}
